<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from "vue";

const trainingSection = ref<HTMLElement | null>(null);
const isVisible = ref(false);
let observer: IntersectionObserver | null = null;

onMounted(() => {
    if (!trainingSection.value) {
        return;
    }

    observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) {
                    return;
                }

                isVisible.value = true;
                observer?.unobserve(entry.target);
            });
        },
        {
            threshold: 0.05,
            rootMargin: "0px 0px -10% 0px"
        }
    );

    observer.observe(trainingSection.value);
});

onBeforeUnmount(() => observer?.disconnect());
</script>

<template>
    <div id="training" ref="trainingSection" :class="{ 'is-visible': isVisible }" class="p-4 pb-8 lg:pb-32 text-center relative">
        <div class="training-copy text-xl lg:text-3xl pb-4">
            <p class="font-light py-0">Chcesz najpierw przetestować swoje umiejętności <br class="blck lg:hidden"/> na wirtualnym torze?</p>
            <p class="font-bold py-0">Wejdź do gry i trenuj jak prawdziwy rajdowiec!</p>
        </div>
        <div class="training-cta py-4">
            <a role="button" class="cta-button block leading-none text-xs w-fit text-center tracking-wider !px-28" href="/trening">TRENUJ</a>
        </div>
    </div>
</template>

<style scoped>
.training-copy,
.training-cta {
    opacity: 0;
    transform: translateY(18px);
    transition: transform 0.55s ease, opacity 0.55s ease;
}

.training-cta {
    transition-delay: 0.12s;
}

.cta-button {
    position: relative;
    overflow: hidden;
    transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.cta-button::before {
    content: "";
    position: absolute;
    inset: 0 auto 0 -140%;
    width: 42%;
    background: linear-gradient(115deg, transparent 0%, rgba(255, 255, 255, 0.16) 35%, rgba(255, 255, 255, 0.45) 50%, transparent 100%);
    transform: skewX(-22deg);
    transition: left 0.45s ease;
    pointer-events: none;
}

.cta-button:hover {
    transform: scale(1.03);
    box-shadow: 0 14px 34px rgba(237, 27, 35, 0.28);
}

.cta-button:hover::before {
    left: 135%;
}

.cta-button:active {
    transform: scale(0.97);
    transition-duration: 0.1s;
}

#training.is-visible .training-copy,
#training.is-visible .training-cta {
    opacity: 1;
    transform: translateY(0);
}
</style>
